import type { Module } from "./roles";

/**
 * Which services a staff address belongs to. Anyone who has at least one of them may open it; an
 * address that returns null belongs to no service. Used to tell "you don't have this service"
 * apart from "this page doesn't exist" when the route is not offered to the signed-in person.
 */
export function staffServicesFor(path: string): Module[] | null {
  const p = path.split(/[?#]/)[0]!.replace(/\/+$/, "") || "/";
  const under = (base: string) => p === base || p.startsWith(`${base}/`);
  if (under("/tax/compliance")) return ["tax", "bookkeeping"];
  if (under("/tax") || /^\/clients\/[^/]+\/tax-input$/.test(p)) return ["tax"];
  if (under("/accounting")) return ["bookkeeping"];
  if (under("/payroll")) return ["payroll"];
  if (under("/advisory")) return ["advisory"];
  if (under("/deadlines")) return ["tax", "payroll", "bookkeeping"];
  return null;
}

/** Client-portal addresses that need full access; a documents-only user is told so instead of seeing an empty page. */
const FULL_ACCESS_PORTAL = ["/invoices", "/book", "/refunds", "/messages", "/tax-payments", "/tax-plan", "/books", "/cfo", "/payroll"];

export function portalNeedsFullAccess(path: string): boolean {
  const p = path.split(/[?#]/)[0]!;
  return FULL_ACCESS_PORTAL.some((b) => p === b || p.startsWith(`${b}/`));
}

export const DOCUMENTS_ONLY_MESSAGE = "Your access is documents only. Contact your firm if you need more.";
export const NO_SERVICE_MESSAGE = "You don't have access to this service";
